/**
 * Resource media (HLS streaming, transcripts and audio) for course sessions
 * and KB steps. Mirrors `CCMSLib.Models.Resources.ResourceMediaView` and
 * friends (JSON is camelCase).
 *
 * Every URL is null when its feature is switched off in ResourceSettings or
 * the media is not ready yet, so clients fall back to the session's original
 * `sessionURL` / step `mediaURL`. Nothing here replaces those fields.
 */
/**
 * FileMediaStatus lookup ids. Names come from the seeded lookup table and are
 * echoed on every view as `mediaStatusName`; these constants only exist so
 * callers can branch without string matching.
 */
export const ResourceMediaStatusIds = {
    NotProcessed: 1,
    Queued: 2,
    Processing: 3,
    Ready: 4,
    Failed: 5,
    NotApplicable: 6,
};
//# sourceMappingURL=ResourceMedia.js.map